import React from 'react';
import Contact from '../components/contact';

const ContactUs = () => {
  return <Contact />;
};

export default ContactUs;
